<template>
  <Modal @close="closeModal">
    <div class="p-modal__content__header">
      {{ $t('pages.companies.analysis.table.stores') }}
    </div>
    <div class="p-modal__content__body">
      <div class="c-grid">
        <div class="c-grid__items">
          <div v-for="(storeName, index) in storeNames" :key="index" class="item c-grid__item__s__6">
            {{ storeName }}
          </div>
        </div>
      </div>
    </div>
    <div class="p-modal__content__footer">
      <div class="c-button c-button--right">
        <div class="js-close" />
        <button
          class="c-button__item c-button__item--outline-cancel"
          @click="closeModal"
          v-text="$t('labels.close')"
        />
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from '../Modal.vue'

export default {
  name: 'CompaniesAnalysisStoreModal',
  components: {
    Modal
  },
  props: {
    storeNames: {
      type: Array,
      required: true,
    }
  },
  emits: ['close'],
  methods: {
    closeModal() {
      this.$emit('close')
    },
  }
}
</script>

<style lang="scss" scoped>
.item {
  padding: 0 12px 12px;
}
</style>
